export const RECEIVE_USER_INFO = 'receive_user_info' //保存用户信息
